import ElementDialogButton from "plos/src/components/ElementDialogButton";
import ElementInTable from "plos/src/components/ElementInTable";
import {
  listTableElementWrap,
  listTableRowStyles,
  myTeamTableElement,
} from "plos/src/styles/listTables.css";
import { visuallyHidden } from "plos/src/styles/utils.css";
import OverlayCells from "../../../ListViewTable/OverlayCells";
import { MyTeamTableRowProps } from "../types";

const MyTeamTableRow = ({
  chipInPlayName,
  pick,
  element,
  teamsById,
  handleElementClick,
  renderDreamTeam,
  overlay,
  stats,
}: MyTeamTableRowProps) => {
  return (
    <tr className={listTableRowStyles}>
      <th scope="row" className={myTeamTableElement}>
        <span className={visuallyHidden}>
          {element.web_name}, {teamsById[element.team].name}
        </span>
        <div className={listTableElementWrap} aria-hidden="true">
          <ElementDialogButton elementId={element.id} variant="list" />
          <ElementInTable
            element={element}
            team={teamsById[element.team]}
            actionMe={() => handleElementClick(pick)}
            chipName={chipInPlayName ?? undefined}
            pick={pick}
            renderDreamTeam={renderDreamTeam}
          />
        </div>
      </th>
      <OverlayCells
        overlay={overlay}
        element={element}
        stats={stats}
        pick={pick}
        pickPrices={{
          purchase_price: pick.purchase_price,
          selling_price: pick.selling_price,
        }}
      />
    </tr>
  );
};

export default MyTeamTableRow;
